/**
 * The honest aggregate behind a transaction filter.
 *
 * GET /transactions is capped (a list has to be). Any "N transactions · $TOTAL"
 * added up from that capped array quietly understates a busy month, and the budget
 * page's "$X is missing from the numbers below" banner was doing exactly that. The
 * Worker computes these in SQL over the whole filtered set, so the screens never
 * add up a truncated page.
 *
 * NOTE for the integrator: this shape belongs in src/shared/types.ts (module agents
 * can't edit it). It is the response of GET /api/transactions/summary.
 */
import { api } from '../../lib/api';

export interface TransactionSummary {
  /** Rows matching the filter — not the number returned by GET /transactions. */
  count: number;
  total: number; // cents
  uncategorized_count: number;
  uncategorized_total: number; // cents
}

export const EMPTY_SUMMARY: TransactionSummary = {
  count: 0,
  total: 0,
  uncategorized_count: 0,
  uncategorized_total: 0,
};

/** `query` is the same query string handed to GET /transactions. */
export function fetchSummary(query: string): Promise<TransactionSummary> {
  return api.get<TransactionSummary>(`/transactions/summary${query ? `?${query}` : ''}`);
}
